import React, { useState } from "react";
import Drawer from "../../Drawer/index";
import { AxiosResponse } from "axios";
import ConfirmPayment from "../../Widgets/ConfirmPayment/ConfirmCardPayment";
import Button from "../../Widgets/Button";
import StripePayNowButton from "../paynowButton/StripePayNowButton";
import {
  isCardDetailsDrawerOpen,
  isPaymentDrawerOpen,
} from "../reducer/PaymentActions";
import useCurrency from "../../../yoello-lib/modules/localisation/useCurrency";
import Style from "./payment.module.scss";
import T from "i18n-react";
import { IPlaceOrder } from "../../../typings/IPayment";
import { addTaxes } from "../../../yoello-lib/modules/utils/TaxController";

interface IPaymentComponentProps {
  isOpen: boolean;
  dispatch: React.Dispatch<any>;
  dispatcher: React.Dispatch<any>;
  paymentDetails: any;
  isLoading: boolean;
  paymentFunction: (
    isUsingPaymentRequest: boolean
  ) => Promise<AxiosResponse<IPlaceOrder>>;
  totalPrice: number;
  userHasPaymentDetails: boolean;
  checkPaymentProceed: () => void;
  successfulTransaction: (orderId: string) => void;
  errorMessenger: (message: string) => void;
  confirmOrder: (orderId: string, token: string) => any;
  retrieveToken: () => Promise<string>;
  cartItemTaxAmount: number | null;
  serviceTaxAmount: number | null;
  deliveryTaxAmount: number | null;
}

/**Handles the confirm payment swipeable drawer */
function PaymentComponent({
  isOpen,
  dispatch,
  dispatcher,
  paymentDetails,
  paymentFunction,
  totalPrice,
  userHasPaymentDetails,
  checkPaymentProceed,
  successfulTransaction,
  errorMessenger,
  confirmOrder,
  retrieveToken,
  cartItemTaxAmount,
  serviceTaxAmount,
  deliveryTaxAmount,
}: IPaymentComponentProps) {
  const [isPaymentLoading, setIsPaymentLoading] = useState(false);
  const { formatCurrency } = useCurrency();
  const totalTax = addTaxes(
    cartItemTaxAmount,
    serviceTaxAmount,
    deliveryTaxAmount
  );
  const total = totalPrice + totalTax;
  const formattedPrice = formatCurrency(total);
  return (
    <Drawer
      isOpen={isOpen}
      closeDrawer={() => {
        if (isPaymentLoading) {
          return;
        }
        dispatch(isPaymentDrawerOpen(false));
      }}
      instructions={[
        T.translate("Payment.SelectYour").toString(),
        T.translate("Payment.PaymentOption").toString(),
      ]}
    >
      <div className={Style.PaymentContainer} id={"PaymentDetailsContainer"}>
        <div className={Style.TotalCost}>
          <p className={Style.TotalPrice}>{T.translate("Payment.TotalPay")}</p>
          <p className={Style.Price}>{formattedPrice}</p>
        </div>
        <StripePayNowButton
          totalCost={totalPrice}
          errorMessenger={errorMessenger}
          successfulTransaction={successfulTransaction}
          createOrder={paymentFunction}
          checkPaymentProceed={checkPaymentProceed}
        />
        <div className={Style.PayWithCard}>
          <div className={Style.Line} />
          <div>
            <p>{T.translate("Payment.PayWithCard")}</p>
          </div>
        </div>
        {userHasPaymentDetails === true ? (
          <ConfirmPayment
            paymentFunction={paymentFunction}
            totalCost={totalPrice}
            paymentDetails={paymentDetails}
            errorMessenger={errorMessenger}
            onSuccessfulTransaction={successfulTransaction}
            confirmOrder={confirmOrder}
            retrieveToken={retrieveToken}
            changeCard={() => {
              dispatch(isPaymentDrawerOpen(false));
              dispatch(isCardDetailsDrawerOpen(true));
            }}
            setIsPaymentLoading={setIsPaymentLoading}
          />
        ) : (
          <Button
            iconClassName="consumer-credit"
            dataComponentName={"AddCardDetaials"}
            isYoelloBtn
            style={{ flexDirection: "row-reverse" }}
            title={"AddCardDetaials"}
            onClick={() => {
              dispatch(isPaymentDrawerOpen(false));
              dispatch(isCardDetailsDrawerOpen(true));
            }}
          />
        )}
      </div>
    </Drawer>
  );
}

export default PaymentComponent;
